export default "__VITE_ASSET__D91SMR1m__"